<template>
  <a-modal
    title="用户数据模块关联"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    :footer="null"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="当前关联数据模块">
              <a-tag closable @close="deleteDataModule(item.id)" v-for="item in currentUserDataRoleList" :key="item.id">
                {{ item.name }}
              </a-tag>
            </a-form-item>
            <a-form-item label="增加关联数据模块">
              <a-select
                mode="tags"
                v-model="userChooseDataModuleList"
                placeholder="请输入"
              >
                <a-select-option :value="item.id" v-for="(item, index) in dataModuleList" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-button @click="addAdminDataModule" type="info">增加</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import {
  user_data_module_create,
  user_data_module_list,
  user_data_module_delete
} from '@/api/user'

// 表单字段
const fields = ['id']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      tip: '',
      form: this.$form.createForm(this),
      dataModuleList: this.$Dictionaries.dataModuleList,
      userChooseDataModuleList: [],
      currentUserDataRoleList: []
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    this.form.setFieldsValue(pick(this.model, fields))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
    this.getInfo()
  },
  methods: {
    deleteDataModule (id) {
      user_data_module_delete(id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          this.getInfo()
        }
      })
    },
    getInfo () {
      user_data_module_list({ admin_id: this.model.id }).then((res) => {
        console.log(res)
        this.currentUserDataRoleList = res.data.entries
        if (this.currentUserDataRoleList !== undefined && this.currentUserDataRoleList.length > 0) {
          this.currentUserDataRoleList = this.currentUserDataRoleList.map(item => {
            for (const dm of this.dataModuleList) {
              if (String(item['data_module']) === dm['id']) {
                item['name'] = dm['name']
              }
            }
            return item
          })
        }
      })
    },
    addAdminDataModule () {
      const param = Object.assign({ user_id: this.model.id, data_modules: this.userChooseDataModuleList.join(',') })
      user_data_module_create(param).then(res => {
        this.userChooseDataModuleList = []
        this.getInfo()
      })
    }
  }
}
</script>
